export default __webpack_public_path__ + "static/media/interpolation.56b1681e.frag";